module.exports = __webpack_public_path__ + "static/img/mocha.57d820d4.svg";